
import { formatSapDate } from '@/mixins/index'
export const pageSearch = {
  'kotabnr': {
    title: '条件表',
    type: 'select',
    dictionary: 'A0101'
  }
}

export default {
  'product_id': {
    title: '产品',
    type: 'input',
    width: 180
  },
  'short_text': {
    title: '产品描述',
    type: 'input',

    width: 300
  },
  'zzfld00001h': {
    title: '营销单元',
    type: 'select',
    dictionary: 'sale'
  },
  'zzfld00001h_text': {
    title: '营销单元描述',
    width: 200
  },
  'partner': {
    title: '客户编号',
    type: 'dialog',
    dialog: {
      component: 'ClientSelect',
      title: '客户编号'
    },
    width: 160
  },
  'name_org1': {
    title: '客户名称',
    type: 'input',
    width: 250
  },
  'kotabnr': {
    title: '条件类型',
    slot: true
  },
  'zpric_type': {
    describe: true,
    title: '价格类型',
    type: 'select',
    dictionary: 'A0020'
  },
  'release_status': {
    describe: true,
    title: '发布状态',
    type: 'select',
    dictionary: 'pricestatus'
  },
  'kbetr': {
    title: '单价',
    xlsxFmt: {
      t: 'n'
    }
  },
  'kmein': {
    title: '产品单位'
  },
  'date_from': {
    title: '有效日期起',
    type: 'date',
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'date_to': {
    title: '有效日期截止',
    type: 'date',
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'changes_number': {
    title: '变动次数'
  },
  'kpein': {
    title: '价格单位'
  }
}



// WEBPACK FOOTER //
// ./src/views/price-manage/config/priceChangeQuery.js